import React, { useContext, useEffect, useState } from "react";
import Header from "../Coman/Header";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { ProjectContext } from "../../ProjectContext";
import { useNavigate } from "react-router-dom";
import { ethers } from "ethers";

function Overview() {
  const { account, toastSuccess, setaccount } = useContext(ProjectContext)
  const [dname, setdname] = useState(null);

  var navigate = useNavigate();

  const godata = async () => {
    setaccount(dname)
    navigate("/dashboard")
    toastSuccess("Here you go!")
  }
  return (
    <div className="padding-top container">
      <div className=" d-flex justify-content-center row mx-2">
        <div className="col-xl-6 col-md-8 mb-4 box-login-size">
          <div className="text-white text-center rounded shadow-lg ">
            <div className="">
              <img
                width={150}
                alt=""
                src="../assets/images/logo/logo-light.svg"
                className="mb-5 img-fluid"
              />
              <br />

              {/* <div className="position-absolute box-new-op start-50 translate-middle w-100 d-flex justify-content-center"> */}
              <div>
                <div className=" mb-4">
                  <div className="text-white text-center rounded shadow-lg">
                    <img src="../assets/img/logo.svg" width="250" alt="" srcset="" />
                    <br />
                    <h2 className="mb-3">Overview</h2>

                    <div className="buy_crypto__formarea-group mb-5 mb-md-6">
                      <div className="d-flex align-items-center br2 p-1 rounded-4 bg1-color">
                        <input type="text" className="form-control" placeholder="Enter Address" onChange={(e) => setdname(e.target.value)} value={dname} />
                      </div>
                    </div>
                    <button onClick={() => godata()} className="th-btn text-white  p-3 px-4  btn-outline-bg-new-primary">Go <i className="fa fa-arrow-right ms-2" /></button>
                  </div>
                </div>
              </div>

              {/* Centered Content */}
              <div className="d-flex justify-content-center mt-5">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Overview;
